import { FC } from 'react';
import { AnalysisGame } from '../../types';
import { gameScoreStyles } from './styles.css';

type Props = {
  game?: AnalysisGame;
};

const GameScore: FC<Props> = ({ game }) => {
  if (!game) {
    return null;
  }

  const isWhiteWinner = game.winner?.playerId === game.whitePlayerId;

  return (
    <span className={gameScoreStyles}>
      {isWhiteWinner ? 1 : 0}-{isWhiteWinner ? 0 : 1}
    </span>
  );
};

export default GameScore;
